/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { ActionButton, Modal, Text } from '@blend/enterprise-components';

import { ModalContent } from 'blb-components/ModalContent';

const styles = StyleSheet.create({
  footerBar: {
    display: 'flex',
    gap: 16,
    justifyContent: 'flex-end',
    marginTop: 28,
  },
});

export interface LOSSyncModalProps {
  handleClose: () => void;
  handleRefresh: () => void;
  isOpen: boolean;
}

export const LOSSyncModal: React.FC<LOSSyncModalProps> = ({ handleClose, handleRefresh, isOpen }) => {
  const handleClick = () => {
    handleRefresh();
    handleClose();
  };

  return (
    <React.Fragment>
      <Modal contentLabel="LOS Sync has occurred" handleClose={handleClose} isOpen={isOpen}>
        <ModalContent handleClose={handleClose} headerText="LOS Sync has occurred">
          <Text data-it="LOSSyncModal-message">
            An LOS sync has happened, please refresh and review the latest fees before you begin your collaboration. The
            latest edit actions will no longer be saved.
          </Text>

          <div className={css(styles.footerBar)}>
            <ActionButton data-it="LOSSyncModal-confirm" label="Refresh" onClick={handleClick} type="submit" />
          </div>
        </ModalContent>
      </Modal>
    </React.Fragment>
  );
};
